var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.537,
    height: 7.537,
    viewBox: "0 0 7.537 7.537",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.769,0A3.769,3.769,0,1,0,7.537,3.769,3.767,3.767,0,0,0,3.769,0Z",
    fill: "#aab7cc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.178,128.5A1.179,1.179,0,0,0,176,129.678a.294.294,0,1,0,.589,0,.589.589,0,1,1,.589.589.294.294,0,0,0-.294.294v.736a.294.294,0,1,0,.589,0v-.479a1.178,1.178,0,0,0-.294-2.318Z",
    transform: "translate(-173.409 -126.608)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 0.368,
    cy: 0.368,
    r: 0.368,
    transform: "translate(3.401 5.204)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.064ba4fb1040b3a6a6ec7f9193c7b3c1.svg";
export { ForwardRef as ReactComponent };